import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { StudioOfferingApiClientContext } from '../studio-offering.context';
function hasDiscountInfo(response) {
  var _response$discount;
  return Boolean((_response$discount = response.discount) == null ? void 0 : _response$discount.discountInfo);
}
export const fetchOfferingDiscountQueryFn = async props => {
  const {
    httpClient
  } = props;
  const {
    getPurchaseDiscount
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = StudioOfferingApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch offering discount');
  }
  const offeringData = await getPurchaseDiscount({
    ...p3Context
  });
  if (hasDiscountInfo(offeringData)) {
    return {
      ...offeringData,
      hasSale: true
    };
  }
  return {
    ...offeringData,
    hasSale: false
  };
};
//# sourceMappingURL=fetch-offering-discount.query.js.map